import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Convert hex color to HSL string for CSS variables
 * Ensures compatibility with Strapi theme colors loaded from /assets/theme/colors.json
 * @param hex - Hex color string (with or without #)
 * @returns HSL string in format "H S% L%"
 */
/**
 * Extrai as iniciais de um nome (máximo 2 caracteres)
 * @param name - Nome completo
 * @returns Iniciais em maiúsculas (ex: "João Silva" → "JS")
 */
export function getInitials(name: string): string {
  return name
    .split(' ')
    .map(word => word[0])
    .filter(Boolean)
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

/**
 * Convert hex color to HSL string for CSS variables
 * Ensures compatibility with Strapi theme colors loaded from /assets/theme/colors.json
 * @param hex - Hex color string (with or without #)
 * @returns HSL string in format "H S% L%"
 */
export function hexToHSL(hex: string): string {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  if (!result) return '0 0% 0%';

  let r = parseInt(result[1], 16) / 255;
  let g = parseInt(result[2], 16) / 255;
  let b = parseInt(result[3], 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h = 0,
    s = 0,
    l = (max + min) / 2;

  if (max !== min) {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r:
        h = ((g - b) / d + (g < b ? 6 : 0)) / 6;
        break;
      case g:
        h = ((b - r) / d + 2) / 6;
        break;
      case b:
        h = ((r - g) / d + 4) / 6;
        break;
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}
